import PROJECTAPI from '@/api/intermodality/project';
export default {
  data() {
    return {
      projectStatus: '',
      upPartners: [],
      downPartners: [],
      routes: [],
      cargos: [],
      attachments: [],
      //关联的供方合同
      assoSupConts: [],
      //关联的客方合同
      assoCusConts: [],
      serviceQuotations: [],
      checkedServiceTypes: [],
      checkedProductTypes: [],
      origin: '',
      baseInfoData: {
        bidClosingDate: null,
        bidOpeningDate: null,
        bidTitle: '',
        bidTotalAmount: null,
        bidderId: '',
        bidderName: '',
        companyCode: '',
        companyName: '',
        linkedCompanyCode: '',
        linkedCompanyName: '',
        createDepartmentName: null,
        createDepartmentNo: null,
        // saleDepartmentName: '',
        // saleDepartmentNo: '',
        projectName: '',
        projectCode: '',
        projectSourceType: '',
        projectOverallDescription: '',
        //上下游信息
        // upPartnerCode: '',
        // upPartnerName: '',
        // upPartnerContactEmail: '',
        // upPartnerContactPerson: '',
        // upPartnerContactPhone: '',
        // upPartnerLegalPerson: '',
        // upPartnerNature: null,
        // upPartnerPayMethod: [],
        // upPartnerReconciliationRules: null,
        // downPartnerCode: '',
        // downPartnerContactEmail: '',
        // downPartnerContactPerson: '',
        // downPartnerContactPhone: '',
        // downPartnerLegalPerson: '',
        // downPartnerName: '',
        // downPartnerNature: null,
        // downPartnerPayMethod: [],
        // downPartnerReconciliationRules: null,
        //项目状态需要判断很多逻辑fixme
        projectStatus: null,
        //产品服务类型：fixme
        productTypeName: null,
        productType: null,
        serviceTypeCode: null,
        serviceTypeName: null,
        //   type: 0,
        projectEndDate: '',
        projectProfitDescription: '',
        projectProfitModel: '',
        projectRiskPoints: '',
        projectStartDate: '',
        riskPreventionMeasures: '',
        //业务类型
        projectBusinessTypeName: null,
        projectBusinessTypeNo: null,

        //平台公司
        platformCompanyCode: null,
        platformCompanyName: null,

        createBy: null,
        createByName: null,
        gmtCreate: null,
        gmtModified: null,
        // invalidReason: '',
        lastModifiedBy: null,
        lastModifiedByName: null,
        applyDate: null,

        //oa字段
        estimatedProfit: null,
        isBidBusiness: null,
        collectionDays: null,
        businessCycle: null,
        projectSort: null,
      },
    };
  },
  computed: {
    allContractDisabled() {
      let merge = this.assoCusConts.concat(this.assoSupConts);
      console.log('mergedList', merge);
      //全部作废
      if (Array.from(merge).every((item) => item.contractStatus == 'ZT05')) {
        return true;
      }
      return false;
    },
  },
  methods: {
    assoChanged(chartType, list) {
      if (chartType == 'customer') {
        this.assoCusConts = list;
      } else {
        this.assoSupConts = list;
      }
      // let mergeList = this.assoCusConts.concat(this.assoSupConts);
    },
    async getProjectDetailById(id) {
      var res = await this.$axios.post(PROJECTAPI.DETAIL_BY_ID, { id });
      if (res.data.code === 0) {
        return res.data.data.length ? res.data.data[0] : {};
      } else {
        this.$message({ showClose: true, message: res.data.msg, type: 'error' });
      }
      return {};
    },
    async initDetail() {
      console.log('request', this.$route.query?.projectCode, this.$route.query?.pageMode);
      let origin = this.$route.query?.origin;
      let projectCode = this.$route.query?.projectCode;
      let changeId = this.$route.query?.changeId; //变更历史的行id
      if (this.pageMode == 1) {
        //拉取详情数据
        var copyFlag = null;
        if (origin == 'copy') {
          copyFlag = '1';
        }
        if (projectCode) {
          this.loading.startLoading();
          let data = {};
          // 点击变更历史行获取后获取数据
          if (changeId) {
            data = await this.getProjectDetailById(changeId, copyFlag);
          } else {
            let res = await this.getProjectDetail(projectCode, copyFlag);
            data = res.data;
          }

          this.loading.endLoading();

          // if (data.platformCompanyCode && typeof data.platformCompanyCode == 'string') {

          // }
          if (data.platformCompanyName && typeof data.platformCompanyName == 'string') {
            data.platformCompanyName = data.platformCompanyName.split(',');
          }

          // if (data.upPartnerPayMethod?.length != 0 && typeof data.upPartnerPayMethod == 'string') {
          //   if (data.upPartnerPayMethod.includes(',')) {
          //     data.upPartnerPayMethod = data.upPartnerPayMethod.split(',');
          //   } else {
          //     data.upPartnerPayMethod = [data.upPartnerPayMethod];
          //   }
          // }

          // if (
          //   data.downPartnerPayMethod?.length != 0 &&
          //   typeof data.downPartnerPayMethod == 'string'
          // ) {
          //   if (data.downPartnerPayMethod.includes(',')) {
          //     data.downPartnerPayMethod = data.downPartnerPayMethod.split(',');
          //   } else {
          //     data.downPartnerPayMethod = [data.downPartnerPayMethod];
          //   }
          // }

          Object.keys(data).forEach((key) => {
            let value = data[key];
            if (!value || value == undefined || value == null) {
              value = '';
            }
            this.baseInfoData[key] = value;
          });

          //选项要勾选上
          // if (this.baseInfoData.bidTitle) {
          //   this.baseInfoData.bidTitle = this.signTitleList.find(
          //     (item) => item.label == this.baseInfoData.bidTitle
          //   )?.value;
          // }

          // if (this.baseInfoData.platformCompany) {
          //   this.baseInfoData.platformCompany = this.platformCompanyList.find(
          //     (item) => item.label == this.baseInfoData.platformCompanyName
          //   )?.value;
          // }

          if (copyFlag == '1') {
            //清空部分数据
            this.baseInfoData.projectName = null;
            this.baseInfoData.projectCode = null;
            this.baseInfoData.bidOpeningDate = null;
            this.baseInfoData.bidOpeningDate = null;
            this.baseInfoData.applyDate = null;
            this.baseInfoData.bidTotalAmount = 0;
            this.baseInfoData.projectStartDate = null;
            this.baseInfoData.projectEndDate = null;
            this.baseInfoData.projectBusinessTypeNo = null;
            this.baseInfoData.projectBusinessTypeName = null;
            this.baseInfoData.projectStatus = null;
            this.baseInfoData.lastModifiedBy = null;
            this.baseInfoData.lastModifiedByName = null;
            this.baseInfoData.createBy = null;
            this.baseInfoData.createByName = null;
            if (this.baseInfoData.id) {
              delete this.baseInfoData.id;
            }

            //还原页面状态
            this.pageMode = 0;
          }
          console.log('baseInfoChanged', this.baseInfoData);

          this.upPartners = data['upCooperativePartners'];
          this.downPartners = data['downCooperativePartners'];
          this.routes = data['routes'];
          this.cargos = data['cargos'];
          this.serviceQuotations = data['serviceQuotations'];
          this.attachments = data['attachments'];
          this.assignTypes();
        }
        //要处理baseinfo,cargos,routes,servicequotations
        //fixme
      }

      if (origin != 'detail') {
        // console.log("创建",this.baseInfoData)
        //新增和复制
        setTimeout(() => {
          this.baseInfoData = {
            ...this.baseInfoData,
            createBy: this.userInfo.userCode,
            createByName: this.userInfo.userName,
            lastModifiedBy: this.userInfo.userCode,
            lastModifiedByName: this.userInfo.userName,
            createDepartmentName: this.userInfo.departmentName,
            createDepartmentNo: this.userInfo.departmentCode,
            gmtCreate: this.formatDateCustom(new Date()),
            gmtModified: this.formatDateCustom(new Date()),
            applyDate: this.formatDateCustom(new Date()),
          };
          // 不为供应链运输事业部时，默认平台公司为当前公司
          if (this.userInfo.companyCode != 'OAC19') {
            this.baseInfoData = {
              ...this.baseInfoData,
              platformCompanyName: [this.userInfo.companyName],
              platformCompanyCode: this.userInfo.companyCode,
            };
          }
          // console.log(this.baseInfoData)
          console.log('创建', this.baseInfoData);
          this.clearValidate();
        }, 500);
      }

      let statusName = this.getStatusName('project', this.baseInfoData.projectStatus);
      this.getProcessedBaseColumns(statusName, origin);
      console.log('processedData', this.baseInfoData);
    },

    convertContract(val, projectCode, partnerCode) {
      let suffix = val == '0' ? 'customerContractCreation' : 'supplierContractCreation';
      let name = val == '0' ? '客方合同创建' : '供方合同创建';
      let query = {
        pageMode: 0,
        origin: 'createFrom',
      };
      if (projectCode) {
        query.projectCode = projectCode;
      }
      if (partnerCode) {
        query.partnerCode = partnerCode;
      }
      let path = {
        path: '/intermodality/' + suffix,
        name: suffix,
        meta: {
          keepAlive: true,
          title: name,
        },
        query: query,
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },

    handleChartChange(chartName, dataList) {
      switch (chartName) {
        case 'cargo':
          this.cargos = dataList;
          console.log('cargoChanged', this.cargos);
          break;
        case 'route':
          this.routes = dataList;
          console.log('routeChanged', this.routes);
          break;
        case 'serviceQuotation':
          this.serviceQuotations = dataList;
          console.log('serviceQuotationChanged', this.serviceQuotations);
          break;
        case 'upPartners':
          this.upPartners = dataList;
          console.log('upPartnersChanged', this.upPartners);
          break;
        case 'downPartners':
          this.downPartners = dataList;
          console.log('downPartnersChanged', this.downPartners);
          break;
      }
    },

    // departmentChangeHandler({ val, prop }) {
    //   console.log('departmentChanged', val, prop);
    //   // if (prop == 'createDepartmentName') {
    //   //   this.baseInfoData.createDepartmentNo = val.id;
    //   //   this.baseInfoData.createDepartmentName = val.label;
    //   // } else if (prop == 'saleDepartmentName') {
    //   //   this.baseInfoData.saleDepartmentNo = val.id;
    //   //   this.baseInfoData.createDepartmentName = val.label;
    //   // }
    //   // console.log('id selected', this.baseInfoData.createDepartmentName, this.baseInfoData.createDepartmentNo);
    // },
    async changeValueHandler({ prop, val }) {
      console.log('valuechanged', prop, val);
      // if (prop == 'upPartnerCode') {
      //   // this.baseInfoData.upPartnerCode = val[0].partnerCode;
      //   // this.baseInfoData.upPartnerName = val[0].partnerZhName;
      //   // this._assignAdditionalInfo(val[0].partnerCode);
      // } else if (prop == 'downPartnerCode') {
      //   // this.baseInfoData.downPartnerCode = val[0].partnerCode;
      //   // this.baseInfoData.downPartnerName = val[0].partnerZhName;
      //   // this._assignAdditionalInfo(val[0].partnerCode, false);
      // } else
      if (prop == 'bidderId') {
        this.baseInfoData.bidderId = val[0].id;
        this.baseInfoData.bidderName = val[0].personName;
      } else if (prop == 'linkedCompanyCode') {
        this.baseInfoData.linkedCompanyCode = val[0].value;
        this.baseInfoData.linkedCompanyName = val[0].label;
        console.log('联动单位', this.baseInfoData);
      } else if (prop == 'projectStartDate') {
        if (this.baseInfoData.projectEndDate && val > this.baseInfoData.projectEndDate) {
          this.$message.error('不能晚于结束日期');
          // var date = Date.from(this.baseInfoData.projectEndDate);
          // date = date.setDate(date.getDate() - 1);
          this.baseInfoData.projectStartDate = null;
        }
      } else if (prop == 'projectEndDate') {
        if (this.baseInfoData.projectStartDate && val < this.baseInfoData.projectStartDate) {
          this.$message.error('不能早于开始日期');
          // var date = new Date(this.baseInfoData.projectStartDate);
          // date = date.setDate(date.getDate() + 1);
          this.baseInfoData.projectEndDate = null;
        }
      } else if (prop == 'applyDate') {
        if (this.baseInfoData.bidOpeningDate && val > this.baseInfoData.bidOpeningDate) {
          this.$message.error('不能晚于投标开始日期');
          this.baseInfoData.applyDate = null;
        }
        if (this.baseInfoData.bidClosingDate && val > this.baseInfoData.bidClosingDate) {
          this.$message.error('不能晚于投标结束日期');
          this.baseInfoData.applyDate = null;
        }
      } else if (prop == 'bidOpeningDate') {
        if (this.baseInfoData.applyDate && val < this.baseInfoData.applyDate) {
          this.$message.error('不能早于申请日期');
          this.baseInfoData.bidOpeningDate = null;
        }
        if (this.baseInfoData.bidClosingDate && val > this.baseInfoData.bidClosingDate) {
          this.$message.error('不能晚于投标结束日期');
          this.baseInfoData.bidOpeningDate = null;
        }
      } else if (prop == 'bidClosingDate') {
        if (this.baseInfoData.applyDate && val < this.baseInfoData.applyDate) {
          this.$message.error('不能早于申请日期');
          this.baseInfoData.bidClosingDate = null;
        }
        if (this.baseInfoData.bidOpeningDate && val < this.baseInfoData.bidOpeningDate) {
          this.$message.error('不能早于投标开始日期');
          this.baseInfoData.bidClosingDate = null;
        }
      } else if (prop == 'platformCompanyName') {
        let info = await this.getPlatformCompanyInfoByName(val);
        // this.baseInfoData.platformCompanyName = info.map((item) => {
        //   return item.createCompanyName;
        // });
        this.baseInfoData.platformCompanyCode = info
          .map((item) => {
            return item.createCompanyCode;
          })
          .join(',');
        console.log('platformChanged', this.baseInfoData);
      } else if (prop == 'projectSourceType') {
        let origin = this.$route.query?.origin;
        let statusName = this.getStatusName('project', this.baseInfoData.projectStatus);

        if (val == 'SWQT') {
          this.baseInfoData.isBidBusiness = '0';
        } else if (val == 'TB') {
          this.baseInfoData.isBidBusiness = '1';
        }
        this.getProcessedBaseColumns(statusName, origin);
      }
    },

    // async _assignAdditionalInfo(partnerCode, upPartner = true) {
    //   let additionalInfo = await this.getPartnerInfo(partnerCode);
    //   if (!additionalInfo) {
    //     return;
    //   }
    //   let partnersPersons = additionalInfo.partnersPersons;
    //   if (upPartner) {
    //     this.baseInfoData.upPartnerNature = additionalInfo.enterpriseType;
    //     this.baseInfoData.upPartnerLegalPerson = additionalInfo.legalPerson;
    //     if (partnersPersons && partnersPersons.length) {
    //       this.baseInfoData.upPartnerContactPerson = partnersPersons[0].contactPersonName;
    //       this.baseInfoData.upPartnerContactPhone = partnersPersons[0].mobilePhone;
    //       this.baseInfoData.upPartnerContactEmail = partnersPersons[0].email;
    //     }
    //   } else {
    //     this.baseInfoData.downPartnerNature = additionalInfo.enterpriseType;
    //     this.baseInfoData.downPartnerLegalPerson = additionalInfo.legalPerson;
    //     if (partnersPersons && partnersPersons.length) {
    //       this.baseInfoData.downPartnerContactPerson = partnersPersons[0].contactPersonName;
    //       this.baseInfoData.downPartnerContactPhone = partnersPersons[0].mobilePhone;
    //       this.baseInfoData.downPartnerContactEmail = partnersPersons[0].email;
    //     }
    //   }
    //   // }
    // },
    validateSearch() {
      let count = Object.keys(this.queryData).length;
      for (var key in this.queryData) {
        let value = this.queryData[key];
        if (value == null || value == undefined || value == [] || value == '') {
          count--;
        }
      }
      if (count == 0) {
        this.$message({
          showClose: true,
          message: this.$t('search.nosearchError'),
          type: 'error',
        });
        return false;
      }
      return true;
    },

    async revoke(code, reason) {
      let params = { invalidReson: reason, projectCode: code };
      this.loading = true;
      const { data } = await this.$axios.post(PROJECTAPI.DISCARD, params);
      this.loading = false;

      if (data.code == 0) {
        this.$message.success(data.msg);
        // this.$router.push({ path: '/intermodality/projectMain' });
      } else {
        this.$message.error(data.msg);
      }
    },

    async getProjectAudiitionLogs(code) {
      var res = await this.$axios.post(PROJECTAPI.AUDITION_LOGS + code);
      if (res) {
        return res;
      }
      return null;
    },

    getSubmitPartners(upList, downList) {
      let list = [];
      if (upList && upList.length > 0) {
        upList.forEach((item) => {
          let payString = '';
          if (item.upPartnerPayMethod?.length != 0 && typeof item.upPartnerPayMethod == 'object') {
            payString = item.upPartnerPayMethod.join(',');
          } else {
            payString = item.upPartnerPayMethod;
          }
          list.push({ ...item, flagUpstreamDownstream: '0', upPartnerPayMethod: payString });
        });
      }
      if (downList && downList.length > 0) {
        downList.forEach((item) => {
          let payString = '';
          if (
            item.downPartnerPayMethod?.length != 0 &&
            typeof item.downPartnerPayMethod == 'object'
          ) {
            payString = item.downPartnerPayMethod.join(',');
          } else {
            payString = item.downPartnerPayMethod;
          }
          list.push({ ...item, flagUpstreamDownstream: '1', downPartnerPayMethod: payString });
        });
      }
      return list;
    },

    //type 0保存1提交
    async save(baseData, cargos, routes, serviceQuotations, type = 0) {
      await this.$refs.baseInfoFormRef.getValidateFormData();
      let message = '';

      let upPartnerData = (await this.$refs.upPartnerChartRef.getValidateTableData()).tableData;
      let downPartnerData = (await this.$refs.downPartnerChartRef.getValidateTableData()).tableData;
      let productServiceValid = await this.$refs.productServiceRef.validate().catch((err) => {
        return err;
      });

      if (!productServiceValid) {
        message = '请检查产品和服务是否完成填写!';
      }

      if (type == 1) {
        if (!cargos || !cargos.length) {
          message = '请创建货物信息!';
        }
        if (!routes || !routes.length) {
          message = '请创建线路信息!';
        }
        if (!serviceQuotations || !serviceQuotations.length) {
          message = '请创建服务询报价信息！';
        }
        if (!this.checkServiceRecordsValid(serviceQuotations)) {
          message = '请勾选服务询报价信息中包含的所有服务项！';
        }
        if (
          !this.$refs.fileTableRef.getTableData() ||
          !this.$refs.fileTableRef.getTableData().length
        ) {
          message =
            '请检查“项目材料、营业执照、开票资料、道路运输许可证、法人身份证、其他证件及资料”是否上传！';
        }
      }

      if (message.length > 1) {
        this.$message({
          showClose: true,
          message: message,
          type: 'error',
        });
        return;
      }

      let params = baseData;
      params.cooperativePartners = this.getSubmitPartners(upPartnerData, downPartnerData);
      params.cargos = cargos;
      params.routes = routes;
      params.serviceQuotations = serviceQuotations;
      params.type = type;

      //treeselect用了就特殊处理
      let createModel = params.createDepartmentName;
      // let saleModel = params.saleDepartmentName;

      if (createModel && typeof createModel !== 'string') {
        params.createDepartmentName = createModel.label;
        params.createDepartmentNo = createModel.id;
      }

      if (params.platformCompanyName && typeof params.platformCompanyName == 'object') {
        params.platformCompanyName = params.platformCompanyName.join(',');
      }
      // if (saleModel && typeof saleModel !== 'string') {
      //   params.saleDepartmentName = saleModel.label;
      //   params.saleDepartmentNo = saleModel.id;
      // }

      // if (params.upPartnerPayMethod?.length != 0 && typeof params.upPartnerPayMethod == 'object') {
      //   params.upPartnerPayMethod = params.upPartnerPayMethod.join(',');
      // }

      // if (
      //   params.downPartnerPayMethod?.length != 0 &&
      //   typeof params.downPartnerPayMethod == 'object'
      // ) {
      //   params.downPartnerPayMethod = params.downPartnerPayMethod.join(',');
      // }

      params.applyDate = this.formatDateCustom(params.applyDate);
      params.bidOpeningDate = this.formatDateCustom(params.bidOpeningDate);
      params.bidClosingDate = this.formatDateCustom(params.bidClosingDate);
      params.projectStartDate = this.formatDateCustom(params.projectStartDate);
      params.projectEndDate = this.formatDateCustom(params.projectEndDate);
      params.gmtCreate = this.formatDateCustom(params.gmtCreate);
      params.gmtModified = this.formatDateCustom(params.gmtModified);
      params.attachments = this.$refs.fileTableRef.getTableData();

      params.companyCode = this.userInfo.companyCode;
      params.departmentCode = this.userInfo.departmentCode;
      params.oaId = this.userInfo.oaId;

      this.loading.startLoading();
      const { data } = await this.$axios.post(PROJECTAPI.SAVE, this.convertEmptyToNull(params));
      this.loading.endLoading();

      if (data.code == 0) {
        this.$message.success(data.msg);
        this.returnPath();
      } else {
        this.$message.error(data.msg);
      }
    },
    returnPath() {
      // 返回列表页
      let path = {
        fromPath: {
          path: this.$route.path,
          name: this.$route.name,
          meta: { keepAlive: true },
        },
        toPath: {
          path: '/intermodality/projectMain',
          name: 'projectMain',
          meta: { keepAlive: false },
        },
      };
      this.$store.dispatch('tagsView/backTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path.toPath);
        });
      });
    },
  },
  mounted() {},
};
